// prepare-notice
export const noticeListApi = 'registration-management/prepare-notice/list'
export const noticeStoreApi = 'registration-management/prepare-notice/store'
export const noticeUpdateApi = 'registration-management/prepare-notice/update'
export const noticeSendApi = 'registration-management/prepare-notice/send'

// notice approval api
export const approvalNoticeListApi = 'registration-management/notice-recommendation-approval/list'
export const approveRecommendNoticeApi = 'registration-management/notice-recommendation-approval/approve-reject'

// application list, archiving api
export const applicationListApi = 'registration-management/application-list/list'
export const sendToVerifyReviewApi = 'registration-management/application-list/send-to-verify-review'
export const applicationVerifyReviewApi = 'registration-management/application-list/send-to-approval'
export const applicationApproveArchiveApi = 'registration-management/application-list/approve-archive'
export const instituteApplicationReview = 'registration-management/application-list/inst-review'
export const InstitutionReviewDetails = 'grant-panel/institution-registration/review-view'

/** Dashboard */
export const dashboardApi = 'registration-management/dashboard/list'

// notice recommendation Approval nothi
export const noticeRecommendationApprovalNothi = 'nothi/notice-recommendation-approval/notice-recommendation-nothi'

// registration Approval nothi
export const registrationApprovalNothi = 'nothi/registration-approval/registration-approval-nothi'
